import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./Teams.module.css";
import StudentsList from './StudentsList/StudentsList';
import AllTeams from './AllTeams/AllTeams';
import { DragDropContext } from "react-beautiful-dnd";
import { useParams } from "react-router-dom";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { lessonParticipantsApi, } from "../../../../utils";
import Loader from "../../../UI/Loader";
import WarningPopup from "./shared/WarningPopup/WarningPopup";
import { submissionStatusTextEnum } from "../../../../models/SubmissionStatusEnum";
import TeamsHeader from "./TeamsHeader/TeamsHeader";

const STUDENT_LIST_DROPPABLE_ID = 'studentsList';
const MAX_STUDENTS = 4;
const MIN_TEAMS = 7;


const Teams = ({ lessonMode, setDisplayLastChange, showTeamsPopup }) => {
    const baseDispatch = useDispatch();
    const { texts } = useSelector(state => state.translate);
    const { id, guid, applictionName } = useParams();
    const studyGroupId = id, lessonId = guid;
    const [participantsData, setParticipantsData] = useState({ participantsNotInTeams: [], teams: [] });
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState(null);
    const [videoPopup, setVideoPopup] = useState(null);
    const [anableBasicDivisionButton, setAnableBasicDivisionButton] = useState()

    useEffect(() => {
        if (showTeamsPopup)
            setVideoPopup(true)
    }, [showTeamsPopup]);

    useEffect(() => {
        if (!lessonMode)
            fetchTeams();
        else {
            if (lessonId != 0)
                fetchTeams();
        }
        setAnableBasicDivisionButton(true)
    }, [lessonMode, studyGroupId]);

    useEffect(() => {
        if (lessonMode && lessonId != 0) {
            fetchTeams();
        }
        setAnableBasicDivisionButton(true)
    }, [lessonId]);

    const fetchTeams = () => {
        const lessonParticipantsRangeFilter = {
            studyGroupId,
            lessonId: lessonMode ? lessonId : null,
        }
        setLoading(true);
        lessonParticipantsApi.lessonParticipantsFilterRangePost({ lessonParticipantsRangeFilter }, (error, resdata, response) => {
            setLoading(false);
            if (error) {
                baseDispatch(throwApiError({ userMessage: texts.lessonParticipantsFilterError, error: error, message: "lessonParticipantsFilterRangePost " + error.message, level: 2, component: "Teams", line: 55 }))
            }
            else {
                initParticipantsData(response.body);
            }
        })
    }

    const addTeam = () => {
        const newTeamIndex = Object.keys(participantsData.teams).length + 1;
        const newTeamsArray = { ...participantsData.teams, [newTeamIndex]: { users: [] } };
        setParticipantsData(prevState => ({
            ...prevState,
            teams: newTeamsArray
        }))

    }

    const initParticipantsData = (teams) => {
        const teamOnly = teams.filter(t => t.id != '00000000-0000-0000-0000-000000000000')
        const participantsNotInTeams = teams.filter(t => t.id == '00000000-0000-0000-0000-000000000000')

        const result = {};
        let maxNumber = 0;

        teamOnly.forEach(team => {
            const match = team.user.firstName.match(/\d+/);
            const number = match ? parseInt(match[0]) : null;
            if (number !== null) {
                let key = number.toString();
                if (team.user.firstName.includes("*"))
                    key = key + (team.user.firstName.includes("*") ? "*" : "");
                    result[key] = {
                        submissionStatus: team.submissionStatus,
                        id: team.id,
                        studyGroupId: team.studyGroupId,
                        lessonId: team.lessonId,
                        user: {
                          id: team.user.id,
                          firstName: team.user.firstName,
                          lastName: team.user.lastName,
                          name: team.user.name,
                          isGroup: team.user.isGroup,
                          users: [],
                        },
                        users: [],
                      };
                if (team.user.users && team.user.users.length > 0) {
                    team.user.users.forEach(user => {
                        result[key].users.push({
                            user: {
                                id: user.id,
                                firstName: user.firstName,
                                lastName: user.lastName,
                                name: user.name,
                            },
                        });
                    })
                }
                if (number > maxNumber) {
                    maxNumber = number;
                }
            }
        });
        for (let i = 1; i <= Math.max(maxNumber, MIN_TEAMS); i++) {
            const key = i.toString();
            if (!result[key]) {
                result[key] = { users: [] };
            }
        }
        setParticipantsData(prevState => ({
            ...prevState,
            participantsNotInTeams: participantsNotInTeams,
            teams: result
        }))
    }


    const getUsersByDroppableId = (droppableId) => {
        return droppableId == STUDENT_LIST_DROPPABLE_ID ? [...participantsData.participantsNotInTeams] : [...participantsData.teams[droppableId].users];
    }

    const changeUserGroup = (sourceUsers, destUsers, source, destination) => {

        const confirmChangeUser = (destination, user, toBank, team) => {
            const lessonParticipantChangeInput = {
                studyGroupId: studyGroupId,
                lessonId: lessonMode ? lessonId : null,
                targetId: toBank ? null : team.user ? team.id : null,
                userId: user?.user?.id,
                groupName: toBank ? null : team.user ? null : `${destination.droppableId} צוות`
            }

            setLoading(true);
            lessonParticipantsApi.lessonParticipantsChangePost({ lessonParticipantChangeInput }, (error, resdata, response) => {
                setLoading(false);
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.errorUpdateTeam, error: error, message: "lessonParticipantsAddPost " + error.message, level: 2, component: "Teams", line: 121 }))
                }
                else {
                    initParticipantsData(response.body);
                    setAnableBasicDivisionButton(true)
                    setDisplayLastChange(true)
                }
            })
        }
        const team = participantsData.teams[destination.droppableId];
        let toBank, fromBank
        if (destination.droppableId == STUDENT_LIST_DROPPABLE_ID)
            toBank = true
        if (source.droppableId == STUDENT_LIST_DROPPABLE_ID)
            fromBank = true
        const [user] = sourceUsers.splice(source.index, 1);
        destUsers.splice(destination.index, 0, user);

        const title = texts.WarnALl;
        const content = toBank ? texts.teamStartedToworkWarn : fromBank ? texts.studentStartedToWorkWarn : texts.studentStartedToworKInTeam

        let submissionStatus
        if (source.droppableId == STUDENT_LIST_DROPPABLE_ID)
            submissionStatus = participantsData.participantsNotInTeams?.find(item => item.user.id === user?.user?.id)?.submissionStatus;
        else
            submissionStatus = participantsData.teams[source.droppableId]?.submissionStatus
        if (submissionStatus == submissionStatusTextEnum.hasSubmission) {
            setPopup(
                <WarningPopup headerTitle={texts.dividingTeams} title={title} content={content} setPopup={() => setPopup(null)} >
                    <>
                        <div className={classes.BtnsContainer}>
                            <button className={`${classes.Btn} ${classes.BtnCancel}`} onClick={() => setPopup(null)}>{texts.cancel}</button>
                            <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={() => { confirmChangeUser(destination, user, toBank, team); setPopup(null); }}>{texts.ok}</button>
                        </div>
                    </>
                </WarningPopup>)

        }
        else {
            confirmChangeUser(destination, user, toBank, team);
        }

    }

    const onDragEnd = (dragObject) => {
        const { source, destination } = dragObject;

        if (!destination) return;

        const sourceUsers = getUsersByDroppableId(source.droppableId);
        const destUsers = getUsersByDroppableId(destination.droppableId);

        if (source.droppableId === destination.droppableId) {
            return
        }
        else {
            if (destination.droppableId != STUDENT_LIST_DROPPABLE_ID && destUsers.length === MAX_STUDENTS) return;
            changeUserGroup(sourceUsers, destUsers, source, destination);
        }

    };

    const deleteTeam = (listId = null) => {
        const confirmDeleteTeam = (team) => {
            setLoading(true);
            const lessonParticipantDeleteRangeInput = {
                studyGroupId: studyGroupId,
                lessonId: lessonMode ? lessonId : null,
                id: team ? team.id : null
            }
            lessonParticipantsApi.lessonParticipantsDeleteRangePost({ lessonParticipantDeleteRangeInput }, (error, resdata, response) => {
                setLoading(false);
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.errorDeleteStudentFromTeam, error: error, message: "lessonParticipantsAddPost " + error.message, level: 2, component: "Teams", line: 261 }))
                }
                else {
                    initParticipantsData(resdata)
                    setAnableBasicDivisionButton(true)
                    setDisplayLastChange(true)
                }
            })
        }
        const title = texts.payAttention;
        const team = participantsData?.teams[listId];
        const content = team ? `${texts.teamStartedToworkWarn}` : texts.studentsStatredToWork
        let hasSubmission
        if (team)
            hasSubmission = team.submissionStatus == submissionStatusTextEnum.hasSubmission
        else
            hasSubmission = Object.values(participantsData.teams).
                some(entry => entry.submissionStatus === submissionStatusTextEnum.hasSubmission);
        if (hasSubmission) {
            setPopup(
                <WarningPopup headerTitle={texts.dividingTeams} title={title} content={content} close={() => setPopup(null)}>
                    <>
                        <div className={classes.BtnsContainer}>
                            <button className={`${classes.Btn} ${classes.BtnCancel}`} onClick={() => setPopup(null)}>{texts.cancel}</button>
                            <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={() => { confirmDeleteTeam(team); setPopup(null); }}>{texts.ok}</button>
                        </div>
                    </>
                </WarningPopup>)
        }
        else {
            confirmDeleteTeam(team);
        }

    }


    return (
        <div className={classes.Teams}>
            {loading && <Loader />}
            <TeamsHeader
                setPopup={setPopup}
                setLoading={setLoading}
                lessonMode={lessonMode}
                deleteTeam={deleteTeam}
                fetchTeams={fetchTeams}
                participantsData={participantsData}
                setDisplayLastChange={setDisplayLastChange}
                setSearchTerm={setSearchTerm}
                videoPopup={videoPopup}
                setVideoPopup={setVideoPopup}
                setAnableBasicDivisionButton={setAnableBasicDivisionButton}
                anableBasicDivisionButton={anableBasicDivisionButton}
                searchTerm={searchTerm}
            >
            </TeamsHeader>
            <div className={classes.TeamsContainer}>
                {participantsData?.participantsNotInTeams && <DragDropContext onDragEnd={onDragEnd} >
                    <StudentsList listId={STUDENT_LIST_DROPPABLE_ID} users={participantsData.participantsNotInTeams} searchTerm={searchTerm} />
                    <AllTeams
                        data={participantsData.teams}
                        addTeam={addTeam}
                        searchTerm={searchTerm}
                        deleteTeam={deleteTeam} />
                </DragDropContext>}
            </div>
            {popup}
        </div>

    )
}

export default Teams;